<template>
  <div class="main-card p-4 w-100 shadow-sm">
    <div class="mb-4">
      <a href="javascript:void(0)" class="btn-back" @click="$emit('prev-step')">
        <img class="me-2" src="@/assets/img/nganluong/icon-back.svg" /> Quay lại
      </a>
    </div>

    <div class="logo-wrapper mx-auto">
      <img src="@/assets/img/nganluong/icon-otp.svg" />
    </div>

    <div class="text-center mb-3 mt-3">
      <h1 class="title-main fw-bold text-uppercase mb-3">Xác thực bảo mật</h1>
      <p class="text-center desc-text mb-0">
        Mã xác thực (OTP) đã được gửi đến {{ sendToText }}
        <br />
        <strong class="text-center text-dark">{{ sendToValue }}</strong>
      </p>
    </div>

    <div :class="['otp-group mt-4', { 'otp-group-erross': !!messageError }]">
      <input
        v-for="(digit, index) in 6"
        :key="index"
        type="number"
        class="otp-input form-control"
        maxlength="1"
        max="9"
        min="0"
        v-model="otp[index]"
        @input="handleInput($event, index)"
        @keydown="handleKeydown($event, index)"
        @paste.prevent="handlePaste($event)"
        :ref="'otpInput' + index"
      />
    </div>
    <p v-if="messageError" class="text-danger text-center mt-2">{{ messageError }}</p>

    <div class="text-center countdown-text mt-3">
      <template v-if="timeLeft > 0">
        Mã hết hạn sau: <span class="countdown-time">{{ formattedTime }}</span>
      </template>
      <template v-else>
        Không nhận được mã?
        <a href="javascript:void(0)" class="resend-link" @click="resendOtp">Gửi lại mã</a>
      </template>
    </div>

    <b-button
      block
      :variant="isFullOtp ? 'primary' : 'secondary'"
      class="w-100 fw-bold py-2 mt-4 btn-nl-confirm"
      :disabled="!isFullOtp"
      @click="verifyOtp"
    >
      Hoàn tất xác thực
    </b-button>
  </div>
</template>

<script>
  import { contractNLOtp, contractNLConfirm } from '@/services/customer-support/task'

  const OTP_EXPIRE_TIME = 10

  export default {
    props: ['query', 'updateShowLoading', 'method', 'mobile'],
    data() {
      return {
        otp: ['', '', '', '', '', ''],
        timeLeft: OTP_EXPIRE_TIME,
        timer: null,
        messageError: '',
      }
    },
    computed: {
      sendToText() {
        const mapName = {
          EMAIL: 'email',
          SMS: 'số điện thoại',
          ZNS: 'tin nhắn Zalo',
        }
        return mapName[this.method]
      },
      sendToValue() {
        const mapValue = {
          EMAIL: this.$options.filters.maskEmail(this.query.email),
          SMS: this.$options.filters.maskPhone(this.mobile),
          ZNS: this.$options.filters.maskPhone(this.mobile),
        }
        return mapValue[this.method]
      },
      isFullOtp() {
        return this.otp.every(d => d !== '')
      },
      formattedTime() {
        const mins = Math.floor(this.timeLeft / 60)
          .toString()
          .padStart(2, '0')
        const secs = (this.timeLeft % 60).toString().padStart(2, '0')
        return `${mins}:${secs}`
      },
    },
    mounted() {
      this.startTimer()
      this.$nextTick(() => {
        this.$refs.otpInput0[0].focus()
      })
    },
    methods: {
      startTimer() {
        this.timer = setInterval(() => {
          if (this.timeLeft > 0) this.timeLeft--
          else clearInterval(this.timer)
        }, 1000)
      },
      resetTimer() {
        this.timeLeft = OTP_EXPIRE_TIME
        this.startTimer()
      },
      handleInput(e, index) {
        const val = e.target.value.replace(/[^0-9]/g, '').slice(-1)
        e.target.value = val
        this.$set(this.otp, index, val)
        if (val !== '' && index < 5) {
          this.$refs['otpInput' + (index + 1)][0].focus()
        }
      },
      handleKeydown(e, index) {
        if (e.key === 'Backspace' || e.key === 'Delete') {
          if (this.otp[index] === '' && index > 0) {
            this.$refs['otpInput' + (index - 1)][0].focus()
          }
          return
        }
        // Khoá nhập thêm nếu ô đã có giá trị
        if (this.otp[index] !== '' && /^[0-9]$/.test(e.key)) {
          e.preventDefault()
        }
      },
      handlePaste(e) {
        const digits = (e.clipboardData.getData('text') || '')
          .replace(/[^0-9]/g, '')
          .slice(0, 6)
          .split('')
        digits.forEach((d, i) => this.$set(this.otp, i, d))
        const lastIndex = Math.min(digits.length, 5)
        this.$nextTick(() => {
          this.$refs['otpInput' + lastIndex][0].focus()
        })
      },

      async verifyOtp() {
        try {
          this.messageError = ''
          this.updateShowLoading(true)
          const res = await contractNLConfirm({
            taskId: this.query.taskId,
            checksum: this.query.checksum,
            email: this.query.email,
            time: this.query.time,
            otp: this.otp.join(''),
            source: this.query.source ? this.query.source : undefined,
          })
          if (res.code === 1000) {
            this.$emit('next-step')
          } else {
            this.messageError = res.message ?? res.error
          }
        } catch (error) {
          this.messageError = error.response?.data?.message
            ? error.response.data.message
            : error.message
        } finally {
          this.updateShowLoading(false)
        }
      },

      async resendOtp() {
        try {
          this.updateShowLoading(true)
          const res = await contractNLOtp({
            taskId: this.query.taskId,
            checksum: this.query.checksum,
            email: this.query.email,
            time: this.query.time,
            typeSend: this.method,
          })
          if (res.code === 1000) {
            this.resetTimer()
          } else {
            this.showFailMx(res.message ?? res.error)
          }
        } catch (error) {
          this.showFailMx(
            error.response?.data?.message ? error.response.data.message : error.message
          )
        } finally {
          this.updateShowLoading(false)
        }
      },
    },
    beforeDestroy() {
      clearInterval(this.timer)
    },
  }
</script>

<style scoped>
  .btn-nl-confirm {
    border-radius: 10px;
    font-size: 19px;
  }
</style>
